export const plans = [
  {
    name: "Free",
    price: 0,
    displayPrice: "Demo",
    isTeam: true,
    features: [
      "Access to 30 Practice Tests for 7 Days",
      "AI-Based Basic Skill Evaluation",
      "Industrial Coding & MCQ Questions",
      "Community Access (Read-only)",
      "Limited Performance Insights",
    ],
    excluded: [
      "Live Coding Sessions",
      "Detailed AI Analytics",
      "Weekly Mentorship Sessions",
      "Private Developer Community",
      "Full Course Access",
      "1-on-1 Career Guidance",
    ],
    duration:"7 Days",
    dollar:"0",
    dollarFormatPrice:function () {
      return `${this.dollar}${this.duration}`;
    }
  },
  {
    name: "Basic",
    price: 4999,
    displayPrice: "₹4999",
    features: [
      "Access to 100 Practice Tests (Valid for 1 Year)",
    //  "Access to Live Coding Sessions",
      "Challenge Solutions with Explanation",
      "Weekly Learning Resources",
      "Basic Progress Tracking Dashboard",
      "Improvement Suggestions",
    ],
    excluded: [
      "Private Community Access",
      "Full Course Access",
      "1-on-1 Mentorship",
    ],
    duration:"/year",
    dollar:"$53.57",
   dollarFormatPrice:function(){
    return `${this.dollar}${this.duration}`
   }
  },
  {
    name: "Standard",
    price: 7999,
    displayPrice: "₹7999",
    popular: true,
    features: [
      "Access to 350 Practice Tests (Valid for 1 Year)",
   //   "All Live Coding Sessions",
      "Advanced Challenge Solutions",
     // "Weekly Tutorials & Practice Sets",
      "Private Developer Community Access",
     // "Full Course Access",
      "Detailed AI Performance Analytics",
      "Speed & Accuracy Tracking",
    ],
    excluded: ["1-on-1 Mentorship"],
    duration:"/year",
    dollar:"$85.71",
   dollarFormatPrice:function(){
    return `${this.dollar}${this.duration}`
   }
  },
  {
    name: "Premium",
    price: 9999,
    displayPrice: "₹9999",
    features: [
      "Unlimited Practice Tests (Valid for 1 Year)",
      "Everything in Standard Plan",
     // "1-on-1 Mentorship & Doubt Solving",
      "AI-Based Personalized Skill Roadmap",
      "Career-Oriented Assessments",
    //  "Interview Preparation Modules",
      "Resume & Profile Optimization",
      "Priority Support",
    ],
    excluded: [],
    duration:"/year",
    dollar:"$107.14",
   dollarFormatPrice:function(){
    return `${this.dollar}${this.duration}`
   }
  },
];